/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexDto } from '../../models/backend-opex-dto';
import { BackendOpexRequestDto } from '../../models/backend-opex-request-dto';

export interface SalesOpexsCreate$FormData$Params {
  body: BackendOpexRequestDto;
}

export function salesOpexsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexDto>;
    }),
  );
}

salesOpexsCreate$FormData.PATH = '/api/sales/opexs/';
